import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.main');
import { OnInit } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-main',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.main/view.scss */
p.blue {
  color: blue;
}`],
})
export class PageMainComponent implements OnInit {
  public activeTab: "auto" | "manual" = "auto"; // 기본값: 자동 생성 탭

  constructor(@Inject( Service) public service: Service) {}

  async ngOnInit() {
    await this.service.init();
  }

  public setActiveTab(tab: "auto" | "manual") {
    this.activeTab = tab;
  }
}

export default PageMainComponent;